import { render, staticRenderFns } from "./Rbac.vue?vue&type=template&id=b1ba30fe&"
import script from "./Rbac.vue?vue&type=script&lang=js&"
export * from "./Rbac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports